import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import { Client, LoadTokenDataIn } from '../../../../api/api-reference';

@Component({
  selector: 'app-clear-tamper-setup',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RouterLink,
    FormsModule,
    AngularSvgIconModule,
  ],
  templateUrl: './clear-tamper-setup.component.html',
  styleUrl: './clear-tamper-setup.component.scss',
})
export class ClearTamperSetupComponent {
  data: LoadTokenDataIn = new LoadTokenDataIn();
  constructor(
    private client: Client,
    private toastr: ToastrService,
    private router: Router,
  ) { }

  formatTokenWithDashes(token: string): string {
    // remove spaces
    const cleaned = token.replace(/[\s-]/g, '');

    // have 20 digs?
    if (!/^\d{20}$/.test(cleaned)) {
      throw new Error("Token must be exactly 20 digits.");
    }

    //add - 
    return cleaned.replace(/(\d{4})(?=\d)/g, '$1-');
  }

  onSubmit() {
    this.data.token = this.formatTokenWithDashes(this.data.token!);
    this.client.loadClearTamperToken(this.data).subscribe({
      next: () => {
        this.toastr.success('Successfully saved.');
        this.router.navigate(['/remote-command/token-load/clear-tamper']);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
